module.exports = __webpack_public_path__ + "static/img/IMG_20160930_173609.af033c96.jpg";